export default (props) => (
  /**
   * Ícone de um filtro, cor parametrizada.
   * Encontrado na tabela de atributos
   */
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.85181 0.970716C0.736671 0.818732 0.766539 0.602185 0.918524 0.487045C0.978522 0.441592 1.05173 0.416992 1.127 0.416992H10.095C10.2857 0.416992 10.4402 0.571564 10.4402 0.762237C10.4402 0.837509 10.4156 0.910718 10.3702 0.970716L6.47411 6.11354V10.0717C6.47411 10.1399 6.45394 10.2065 6.41613 10.2632C6.31036 10.4219 6.09601 10.4647 5.93736 10.359L4.90162 9.66848C4.80558 9.60445 4.74789 9.49665 4.74789 9.38122V6.11354L0.85181 0.970716Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
);
